import  { useState } from 'react';
import safeGetProps from 'lodash/get';
import setAttribute from 'lodash/set';

import { FormContextConsumer, IFormPropsContext } from './form-context';

interface IFieldProps {
    component: any;
    label: string;
    name: string;
}

const Field = ({ component: FieldComponent, name, ...props }: IFieldProps & any) => {
    const [touched, setTouched] = useState(false);
    const [blur, setBlur] = useState(false);
    const [focused, setFocus] = useState(false);

    const handleChange = (formContext: IFormPropsContext) => (event: any) => {
        setTouched(true);

        let newValue = null;

        if (event.target) {
            newValue = event.target.type === 'checkbox'
                ? event.target.checked
                : event.target.value;
        } else {
            newValue = event.value;
        }

        formContext.updateValues({
            ...setAttribute(formContext.values, name, newValue)
        });
    }

    return (
        <FormContextConsumer>
            {
                formContext => {
                    const classNames = [];
                    let isValid = false;
                    let errorMessage = '';
                    let formError = null;

                    if (formContext) {
                        try {
                            formContext.schema.validateSyncAt(name, formContext.values);

                            isValid = true;
                        } catch (error) {
                            isValid = false;
                            formError = error;
                        }
                    }

                    if (formContext && !isValid) {
                        if (formContext.submitted || (touched && blur)) {
                            classNames.push('error');
                            errorMessage = formError ? formError.message : '';
                        }
                    }

                    if (focused) {
                        classNames.push('focus');
                    }

                    const value = safeGetProps(formContext, `values.${name}`, null);

                    const { onFocus } = props;

                    return formContext && (
                        <FieldComponent
                            className={classNames.join(' ')}
                            value={value}
                            onChange={handleChange(formContext)}
                            errorMessage={errorMessage}
                            onFocus={() => {
                                setFocus(true);
                                if (onFocus) {
                                    onFocus();
                                }
                            }}
                            onBlur={() => {
                                setBlur(true);
                                setFocus(false);
                            }}
                            {...props}
                        />
                    )
                }
            }
        </FormContextConsumer>
    );
}

export default Field;
